import { render, staticRenderFns } from "./CustomizationBox.vue?vue&type=template&id=5443ec6e&"
import script from "./CustomizationBox.vue?vue&type=script&lang=js&"
export * from "./CustomizationBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationBox.vue?vue&type=style&index=0&id=5443ec6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports